// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PopupContent__Wrapper_XPzbN","Title":"PopupContent__Title_2QIGQ","Link":"PopupContent__Link_2eXUA"};